<template>
    <v-layout wrap>
        <v-flex xs12 py-1>
            <v-text-field
                v-if="isForeign"
                class="search-field"
                :readonly="loadingSearch"
                :loading="loadingSearch"
                ref="searchDNIInput"
                width="200px"
                maxlength="12"
                color="primary"
                hide-details
                :value="dni"
                @input="value => dni = value"
                append-icon="search"
                outline
                clearable
                :label="label"
                type="text"
                @click:append="$refs.searchDNIInput.focus();$refs.searchDNIInput.blur()"
                @click:clear="clearDNI"
                @blur="searchDNI"
                @keyup.enter.native="$refs.searchDNIInput.blur()"
            ></v-text-field>
            <v-text-field
                v-else
                class="search-field"
                :readonly="loadingSearch"
                :loading="loadingSearch"
                ref="searchDNIInput"
                width="200px"
                maxlength="12"
                color="primary"
                hide-details
                :value="dni | rut"
                @input="value => dni = value ? value.replace(/\.\-/g, '') : value"
                append-icon="search"
                outline
                clearable
                :label="label"
                type="text"
                :rules="rutRules"
                @click:append="$refs.searchDNIInput.focus();$refs.searchDNIInput.blur()"
                @click:clear="clearDNI"
                @blur="searchDNI"
                @keyup.enter.native="$refs.searchDNIInput.blur()"
            ></v-text-field>
            <v-checkbox class="mt-0" label="Extranjero" hide-details v-model="isForeign"/>
        </v-flex>
        <patient-sign-up
            :internal="internal"
            :provider-id="providerId"
            :model="showPatientSignUp"
            :onCancel="onSignUpCancel"
            :dni="dni"
            :is-foreign="isForeign"
            :onSignUpSuccess="onSignUpSuccess"
            :requiredFields="requiredFields"
            :requestedFields="requestedFields"
        />
    </v-layout>
</template>
<script>

import {rutValidator, rutFormat} from '@/utils/Common'
import {ApiUtils} from '@/utils/ApiUtils'
import PatientSignUp from '../../../components/common/signup/PatientSignUp.vue'

import {mapMutations} from 'vuex'

export default {
    components: {PatientSignUp},
    props: {
        internal: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: 'Ingresar RUT'
        },
        requiredFields: {
            type: Array
        },
        requestedFields: {
            type: Array
        },
        providerId: {
            type: Number
        },
    },
    data() {
        return {
            showPatientSignUp: false,
            loadingSearch: false,
            foundUser: null,
            rutRules: [
                rutValidator
            ],
            dni: '',
            isForeign: false,
        }
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        clearDNI(evt) {
            var vm = this
            vm.dni = ''
            vm.foundUser = null
        },
        async searchDNI() {
            var vm = this
            if(!vm.dni) return;
            if (rutValidator(vm.dni) !== true && !vm.isForeign) {
                vm.showSnackBar('El RUT ingresado es inválido')
                return
            }

            vm.loadingSearch = true
            const url = vm.internal ? 'user/dni' : 'public/user/dni'
            const response = await ApiUtils.makeGet(url, {
                dni: vm.dni,
                is_foreign: vm.isForeign
            })
            vm.loadingSearch = false

            if (response.ok) {
                const json = await response.json()
                let patient = json.result.user
                vm.foundUser = patient
                return
            }

            const json = await response.json()
            if (json.code == 404) {
                vm.showSnackBar('RUT no encontrado')
                //todo: open patient signup dialog
                vm.showPatientSignUp = true
                vm.foundUser = null
                return
            }

        },
        onSignUpSuccess(user) {
            var vm = this
            vm.foundUser = user
            vm.showPatientSignUp = false
            vm.dni = vm.isForeign ? user.dni : rutFormat(user.dni)
        },
        onSignUpCancel() {
            this.showPatientSignUp = false
        },
        focus() {
            const vm = this
            if(vm.$refs.searchDNIInput) vm.$refs.searchDNIInput.focus()
        }
    },
    computed: {

        client() {

            var vm = this
            if (!vm.foundUser) return null

            return {
                id: vm.foundUser.id,
                avatar: vm.foundUser.avatar,
                gender: vm.foundUser.gender,
                firstName: vm.foundUser.first_name,
                lastName: vm.foundUser.last_names || '',
                email: vm.foundUser.email || '',
                phone1: vm.foundUser.phone1 || '',
                phone2: vm.foundUser.phone2 || '',
            }

        }

    },
    watch: {
        client(val) {
            this.$emit('change', val)
            if (val) {
                this.dni = ''
            }
        },
    }
}
</script>

<style scoped>
/*
.search-field >>>.v-text-field__slot input
{
    margin-top: 5px !important;
    padding: 0 !important;
}
.search-field >>>.v-input__append-inner{
    margin-top: 10px !important;
    padding: 0 !important;
}

.search-field >>>.v-input__slot{
    border-radius: 50px !important;
    padding: 5px 20px !important;
    margin: 5px !important;
}
*/
</style>